module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUAQMAAADWX60MAAAABlBMVEXcFDz////vuDXSAAAAEElEQVQI12P4DwQMJBEkAwCtUSfZb7JSvgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/pl.png
// module id = 910
// module chunks = 0